import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBranchCustomBankList } from '../../../../../../../Redux/action/Organisation/Branch/BranchAction';
import Beatloader from '../../../../../../../Common/Loaders/Beatloader';
import BankDealerAdd from './BankDealerAdd';
import Swal from 'sweetalert2';
import { adminMainUrl } from '../../../../../../../Config';
import axios from 'axios';

const BankDealerList = ({ branch_id, token, user_id, b64id }) => {
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [bankList, setBankList] = useState([]);
    useEffect(() => {
        if (branch_id && token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchCustomBankList(token, user_id, branch_id, id));
            }
        }
    }, [branch_id]);

    const refresh = () => {
        if (branch_id && token && user_id && b64id) {
            let id = atob(b64id);
            if (id) {
                dispatch(getBranchCustomBankList(token, user_id, branch_id, id));
            }
        }
    };

    const { loadingBranchCustomBankList, BranchCustomBankList, BranchCustomBankListError } = useSelector(state => state?.BranchReducer)

    useEffect(() => {
        if (loadingBranchCustomBankList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (BranchCustomBankList) {
            setBankList(BranchCustomBankList);
        }
    }, [loadingBranchCustomBankList, BranchCustomBankList, BranchCustomBankListError]);


    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => { setShowAdd(false) };


    const handleDelete = (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you really want to delete this item?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let values = { id: id, customer_id: atob(b64id), general_branch_id: branch_id }
                    let config = { headers: { "auth-token": token, 'user_id': user_id } }
                    return axios.post(`${adminMainUrl}/api/organization/general/branch/custom_detail/bank/delete`, values, config);
                } else {
                    throw new Error("Deletion canceled");
                }
            })
            .then((response) => {
                Swal.fire("Deleted!", "Your item has been deleted.", "success");
                refresh();
            })
            .catch((error) => {
                if (error.message === "Deletion canceled") {
                    Swal.fire("Cancelled", "Your item is safe.", "info");
                } else {
                    Swal.fire("Error!", error.response?.data?.message || "Something went wrong.", "error");
                }
            });
    };

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <>
                        <div className="card">
                            <div className="card-body">
                                <div className="row my-2">
                                    <div className="col-md-12 text-end">
                                        <button className="btn btn-primary btn-sm" onClick={() => setShowAdd(true)}>+Add</button>
                                    </div>
                                </div>
                                <div className="table-responsive">
                                <table className="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Entity Name</th>
                                            <th scope="col">Bank/Dlr Name and Address</th>
                                            <th scope="col">A/C No.</th>
                                            <th scope="col">AD Code</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bankList.length == 0 ?
                                                <tr>
                                                    <td colSpan={6}>No data found</td>
                                                </tr>
                                                :
                                                bankList.map((val, index) => {
                                                    return <tr>
                                                        <td scope='row'>{index + 1}</td>
                                                        <td scope='row'>{val?.entity_name}</td>
                                                        <td scope='row'>{val?.address}</td>
                                                        <td scope='row'>{val?.account_no}</td>
                                                        <td scope='row'>{val?.ad_code}</td>
                                                        <td>
                                                            {/* <button className="btn btn-sm btn-outline-primary me-1" onClick={() => { handleEditBank(val.id) }}><i className="fas fa-edit"></i></button> */}
                                                            <button className="btn btn-sm btn-outline-danger ms-1" onClick={() => { handleDelete(val.id) }} ><i className="fa-solid fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                })
                                        }
                                    </tbody>
                                </table>
                                </div>
                            </div>
                        </div>
                        <BankDealerAdd
                            show={showAdd}
                            handleClose={handleCloseAdd}
                            refresh={refresh}
                            branch_id={branch_id}
                            token={token}
                            user_id={user_id}
                            b64id={b64id}
                        />
                    </>
            }
        </>
    )
}

export default BankDealerList